import "./styles.scss";
import React, { FC, useEffect, useState } from "react";
import { Timeline } from "react-twitter-widgets";

interface IProps {
  company: { team: []; name: string; company_id: string; twitter_url: string };
  setShowSocialsFeedSection: Function;
}

const CompanySocialsFeedContent: FC<IProps> = (props: IProps) => {
  const { company, setShowSocialsFeedSection } = props;
  // const { paperstreet } = useSelector((state: IState) => state);
  // const { team } = company ? company : [];

  const [twitterScreenName, setTwitterScreenName] = useState();

  useEffect(() => {
    if (!company.twitter_url) {
      setShowSocialsFeedSection(false);
      return;
    }

    let twitterUrlArray = company.twitter_url.split("/");

    let screenName = twitterUrlArray[twitterUrlArray.length - 1];

    // @ts-ignore
    setTwitterScreenName(screenName);
  }, [company.twitter_url]);

  return (
    <div>
      <Timeline
        dataSource={{
          sourceType: "profile",
          screenName: twitterScreenName,
        }}
        options={{
          height: "400",
          width: "400",
        }}
        // renderError={(err) => {
        //   console.log('err :>> ', err);
        //   console.log("Unable to render twitter timeline");
        //   setShowSocialsFeedSection(false);
        //   return null;
        // }}
      />
    </div>
  );
};

export default CompanySocialsFeedContent;
